"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TanklessRo = exports.Catalogue = exports.State = exports.SroMode = exports.SroModeFromCode = exports.Telemetry = exports.LatestTelemetryUpdate = exports.SensorIdentifier = exports.NAMESPACE = exports.Prefs = void 0;
const effect_1 = require("effect");
const Predicate_1 = require("effect/Predicate");
const cellular_1 = require("../../../../network/cellular");
const Unit = __importStar(require("../../../../unit"));
const capability_1 = require("../../capability");
const vendor_1 = require("../../vendor");
const _util_1 = require("../_util");
const Base = __importStar(require("../base"));
const failure_mode_1 = require("./failure-mode");
const Prefs = __importStar(require("./prefs"));
exports.Prefs = __importStar(require("./prefs"));
exports.NAMESPACE = 'Culligan.Device.Class.TanklessRo';
// TODO(Q10/Q13): confirm which operating modes the firmware reports
const operatingModes = [
    'Standard',
    'Disabled',
    'Factory',
    'Fault',
    'Ota',
    'Startup',
    'Installation',
    'Service',
];
const powerProfiles = ['Standard'];
const logLevels = [
    'Debug',
    'Silent',
    'Warning',
    'Trace',
];
// TODO(Q02): confirm the connectivity options
const connectivity = ['Wi-Fi', 'Cellular'];
const Connectivity = Base.makeConnectivity(exports.NAMESPACE, connectivity);
const slots = [
    [capability_1.Consumable.Definition.GlobalTanklessROFilter.GlobalTanklessROFilter],
    [capability_1.Consumable.Definition.GlobalTanklessROMembrane.GlobalTanklessROMembrane],
];
const alarms = {
    consumableBased: [capability_1.Alarm.ConsumableOverused, capability_1.Alarm.ConsumableExpired],
    firmwareBased: [
        // critical
        capability_1.Alarm.BatteryCritical,
        capability_1.Alarm.P1NoPressure,
        capability_1.Alarm.P2Failure,
        capability_1.Alarm.Fm1NoFlowError,
        capability_1.Alarm.Fm2NoFlowError,
        capability_1.Alarm.MembraneFailure,
        capability_1.Alarm.Solenoid1ClosingError,
        capability_1.Alarm.Solenoid1OpeningError,
        capability_1.Alarm.Solenoid2ClosingError,
        capability_1.Alarm.Solenoid2OpeningError,
        capability_1.Alarm.Solenoid3ClosingError,
        capability_1.Alarm.Solenoid3OpeningError,
        capability_1.Alarm.Solenoid4ClosingError,
        capability_1.Alarm.Solenoid4OpeningError,
        capability_1.Alarm.ErrorLeakInternal,
        capability_1.Alarm.ErrorLeakExternal,
        capability_1.Alarm.BatteryStatusError,
        capability_1.Alarm.UvError,
        // non-critical
        capability_1.Alarm.BatteryLow,
        capability_1.Alarm.P1LowPressure,
        capability_1.Alarm.Tds1High,
        capability_1.Alarm.Temp1LowTemp,
        capability_1.Alarm.Temp1HighTemp,
        capability_1.Alarm.Tds2NoTds,
        capability_1.Alarm.Tds1NoTds,
        capability_1.Alarm.TempError,
        capability_1.Alarm.BatteryChargeError,
        capability_1.Alarm.TankFillTimeError,
        capability_1.Alarm.P1HighPressure,
        capability_1.Alarm.P2LowPressure,
    ],
    telemetryBased: [],
};
const commands = [...capability_1.Command.systemCommands];
const sensors = {
    /**
     * Water quality
     */
    // TODO(Q05): confirm the unit of the TDS readings
    tdsFeed: capability_1.Telemetry.Sensor.Number({
        name: 'Feed TDS',
        type: capability_1.Telemetry.WaterTDS,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    tdsPostMembrane: capability_1.Telemetry.Sensor.Number({
        name: 'Post-Membrane TDS',
        type: capability_1.Telemetry.WaterTDS,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    tdsFaucet: capability_1.Telemetry.Sensor.Number({
        name: 'Faucet TDS',
        type: capability_1.Telemetry.WaterTDS,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    // TODO(Q31): confirm the timing difference between rejection and rejectionEnd
    rejection: capability_1.Telemetry.Sensor.Number({
        name: 'Rejection',
        type: capability_1.Telemetry.TdsReduction,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    rejectionEnd: capability_1.Telemetry.Sensor.Number({
        name: 'Rejection at Cycle End',
        type: capability_1.Telemetry.TdsReduction,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    systemEfficiency: capability_1.Telemetry.Sensor.Number({
        name: 'System Efficiency',
        type: capability_1.Telemetry.SystemEfficiency,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    temperature: capability_1.Telemetry.Sensor.Number({
        name: 'Water Temperature',
        type: capability_1.Telemetry.WaterTemperatureFahrenheit,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    /**
     * Pressure and tank
     */
    // TODO(Q05): confirm the unit of the pressure readings
    pumpPressure: capability_1.Telemetry.Sensor.Number({
        name: 'Pump Pressure',
        type: capability_1.Telemetry.WaterPressure,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    // TODO(Q04): confirm which tank-related readings apply to a tankless unit
    tankPressure: capability_1.Telemetry.Sensor.Number({
        name: 'Tank Pressure',
        type: capability_1.Telemetry.WaterPressure,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    tankPercentFull: capability_1.Telemetry.Sensor.Number({
        name: 'Tank Level',
        type: capability_1.Telemetry.TankLevelPercentage,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    lastTankEmpty: capability_1.Telemetry.Sensor.Number({
        name: 'Last Tank Empty',
        type: capability_1.Telemetry.EventTime,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    /**
     * Flow
     */
    // TODO(Q21): confirm that feed is in mL/min and faucet in gal/min
    feedFlowRate: capability_1.Telemetry.Sensor.Number({
        name: 'Feed Flow Rate',
        type: capability_1.Telemetry.FlowRateMilliliterPerMinute,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    faucetFlowRate: capability_1.Telemetry.Sensor.Number({
        name: 'Faucet Flow Rate',
        type: capability_1.Telemetry.FlowRateUsGallonsPerMinute,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    // TODO(Q22): confirm whether the totals are lifetime or since the last filter reset
    feedTotalVolume: capability_1.Telemetry.Sensor.Number({
        name: 'Feed Total Volume',
        type: capability_1.Telemetry.WaterVolumeUsGallons,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    faucetTotalVolume: capability_1.Telemetry.Sensor.Number({
        name: 'Faucet Total Volume',
        type: capability_1.Telemetry.WaterVolumeUsGallons,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    averageMembraneFlowRate: capability_1.Telemetry.Sensor.Number({
        name: 'Average Membrane Flow Rate',
        type: capability_1.Telemetry.FlowRateMilliliterPerMinute,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    // TODO(Q06): the device spec sends gpm x 100; the proposal asks for unscaled gpm
    averageDispenseFlowRate: capability_1.Telemetry.Sensor.Number({
        name: 'Average Dispense Flow Rate',
        type: capability_1.Telemetry.FlowRateUsGallonsPerMinute,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    // TODO(Q27): confirm what peakFlowRate and roProductionDuration measure, and their unit
    peakFlowRate: capability_1.Telemetry.Sensor.Number({
        name: 'Peak Flow Rate',
        type: capability_1.Telemetry.FlowRateMilliliterPerMinute,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    /**
     * Production cycles
     */
    roProductionDuration: capability_1.Telemetry.Sensor.Number({
        name: 'RO Production Duration',
        type: capability_1.Telemetry.CycleDuration,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    productionCycleCount: capability_1.Telemetry.Sensor.Number({
        name: 'Production Cycles',
        type: capability_1.Telemetry.CycleCount,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    // TODO(Q26): the device counter is 1 byte and wraps after 255
    permeateFlushCount: capability_1.Telemetry.Sensor.Number({
        name: 'Permeate Flushes',
        type: capability_1.Telemetry.CycleCount,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    // TODO(Q07): confirm the device can send epoch milliseconds
    lastProductionCycle: capability_1.Telemetry.Sensor.Number({
        name: 'Last Production Cycle',
        type: capability_1.Telemetry.EventTime,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    /**
     * Usage
     */
    // TODO(Q08): confirm whether midnight is local time or UTC
    todaysUsage: capability_1.Telemetry.Sensor.Number({
        name: "Today's Usage",
        type: capability_1.Telemetry.DispenseVolumeUsFluidOunces,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    // TODO(Q29): the cloud may compute weekly and monthly usage instead
    weeklyUsage: capability_1.Telemetry.Sensor.Number({
        name: 'Weekly Usage',
        type: capability_1.Telemetry.DispenseVolumeUsFluidOunces,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    monthlyUsage: capability_1.Telemetry.Sensor.Number({
        name: 'Monthly Usage',
        type: capability_1.Telemetry.DispenseVolumeUsFluidOunces,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    dailyDispenseCount: capability_1.Telemetry.Sensor.Number({
        name: 'Daily Dispense Count',
        type: capability_1.Telemetry.DispenseCount,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    daysInOperation: capability_1.Telemetry.Sensor.Number({
        name: 'Days in Operation',
        type: capability_1.Telemetry.DayCounter,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    // TODO(Q08/Q71): no platform command resets this counter yet
    annualServiceCounter: capability_1.Telemetry.Sensor.Number({
        name: 'Annual Service Counter',
        type: capability_1.Telemetry.DayCounter,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    /**
     * Connectivity
     */
    // TODO(Q30): confirm the unit and scale, and whether rssi refers to Wi-Fi or cellular, then move
    // rssi to SignalStrength
    rssi: capability_1.Telemetry.Sensor.Number({
        name: 'Signal Strength',
        type: capability_1.Telemetry.ReportedSignalStrength,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
    cellSignalQuality: capability_1.Telemetry.Sensor.Number({
        name: 'Cellular Bit Error Rate',
        type: capability_1.Telemetry.CellularBitErrorRate,
        expectedValue: capability_1.Telemetry.ExpectAny,
    }),
};
exports.SensorIdentifier = effect_1.Schema.Literal(...effect_1.Record.keys(sensors)).annotations({
    identifier: `${exports.NAMESPACE}.SensorIdentifier`,
});
exports.LatestTelemetryUpdate = effect_1.Schema.Record({ key: exports.SensorIdentifier, value: effect_1.Schema.DateFromNumber })
    .pipe(effect_1.Schema.partialWith({ exact: true }))
    .annotations({
    identifier: `${exports.NAMESPACE}.LatestTelemetryUpdate`,
});
const events = [];
exports.Telemetry = effect_1.Schema.Struct({
    tdsFeed: capability_1.Telemetry.WaterTDS.FromScalar,
    tdsPostMembrane: capability_1.Telemetry.WaterTDS.FromScalar,
    tdsFaucet: capability_1.Telemetry.WaterTDS.FromScalar,
    rejection: capability_1.Telemetry.TdsReduction.FromScalar,
    rejectionEnd: capability_1.Telemetry.TdsReduction.FromScalar,
    systemEfficiency: capability_1.Telemetry.SystemEfficiency.FromScalar,
    temperature: capability_1.Telemetry.WaterTemperatureFahrenheit.FromScalar,
    pumpPressure: capability_1.Telemetry.WaterPressure.FromScalar,
    tankPressure: capability_1.Telemetry.WaterPressure.FromScalar,
    tankPercentFull: capability_1.Telemetry.TankLevelPercentage.FromScalar,
    lastTankEmpty: capability_1.Telemetry.EventTime.FromScalar,
    feedFlowRate: capability_1.Telemetry.FlowRateMilliliterPerMinute.FromScalar,
    faucetFlowRate: capability_1.Telemetry.FlowRateUsGallonsPerMinute.FromScalar,
    feedTotalVolume: capability_1.Telemetry.WaterVolumeUsGallons.FromScalar,
    faucetTotalVolume: capability_1.Telemetry.WaterVolumeUsGallons.FromScalar,
    averageMembraneFlowRate: capability_1.Telemetry.FlowRateMilliliterPerMinute.FromScalar,
    averageDispenseFlowRate: capability_1.Telemetry.FlowRateUsGallonsPerMinute.FromScalar,
    peakFlowRate: capability_1.Telemetry.FlowRateMilliliterPerMinute.FromScalar,
    roProductionDuration: capability_1.Telemetry.CycleDuration.FromScalar,
    productionCycleCount: capability_1.Telemetry.CycleCount.FromScalar,
    permeateFlushCount: capability_1.Telemetry.CycleCount.FromScalar,
    lastProductionCycle: capability_1.Telemetry.EventTime.FromScalar,
    todaysUsage: capability_1.Telemetry.DispenseVolumeUsFluidOunces.FromScalar,
    weeklyUsage: capability_1.Telemetry.DispenseVolumeUsFluidOunces.FromScalar,
    monthlyUsage: capability_1.Telemetry.DispenseVolumeUsFluidOunces.FromScalar,
    dailyDispenseCount: capability_1.Telemetry.DispenseCount.FromScalar,
    daysInOperation: capability_1.Telemetry.DayCounter.FromScalar,
    annualServiceCounter: capability_1.Telemetry.DayCounter.FromScalar,
    rssi: capability_1.Telemetry.ReportedSignalStrength.FromScalar,
    cellSignalQuality: capability_1.Telemetry.CellularBitErrorRate.FromScalar,
}).annotations({
    identifier: `${exports.NAMESPACE}.Telemetry`,
});
// TODO(Q10): confirm the mapping between sroMode values and the platform operating modes
exports.SroModeFromCode = effect_1.Schema.transformLiterals([0, 'Init'], [1, 'Idle'], [2, 'RoProduction'], [3, 'PermeateFlush'], [5, 'Error'], [6, 'Failsafe'], [7, 'RentalLock']).annotations({
    identifier: `${exports.NAMESPACE}.SroModeFromCode`,
    description: 'Operating state of the reverse-osmosis controller',
});
exports.SroMode = effect_1.Schema.Union(exports.SroModeFromCode, effect_1.Schema.Int).annotations({
    identifier: `${exports.NAMESPACE}.SroMode`,
    description: 'Operating state of the reverse-osmosis controller, or its raw code when unmapped',
});
const InitTankFillDuration = effect_1.Schema.NonNegative.pipe(Unit.Into(Unit.Time.Second)).annotations({
    identifier: `${exports.NAMESPACE}.InitTankFillDuration`,
    description: 'Average duration of the initial tank fills',
});
exports.State = effect_1.Schema.Struct({
    ...Base.State.fields,
    operatingMode: effect_1.Schema.Literal(...operatingModes),
    powerProfile: effect_1.Schema.Literal(...powerProfiles),
    logLevel: effect_1.Schema.Literal(...logLevels),
    connectivity: effect_1.Schema.optionalWith(Connectivity, { exact: true }),
    sroMode: effect_1.Schema.optionalWith(exports.SroMode, { exact: true }),
    // TODO(Q12): the accessory codes are not specified yet
    accessoryInstalled: effect_1.Schema.optionalWith(effect_1.Schema.Int, { exact: true }),
    // TODO(Q07): confirm the device can send epoch milliseconds
    installationDate: effect_1.Schema.optionalWith(effect_1.Schema.DateFromNumber, { exact: true }),
    lastPowerUp: effect_1.Schema.optionalWith(effect_1.Schema.DateFromNumber, { exact: true }),
    // TODO(Q04/Q27): confirm whether a tank-fill duration applies to a tankless unit, and its unit
    initTankFillDuration: effect_1.Schema.optionalWith(InitTankFillDuration, { exact: true }),
    iccid: effect_1.Schema.optionalWith(effect_1.Schema.NullOr(cellular_1.Iccid), { exact: true }),
    sku: effect_1.Schema.optionalWith(effect_1.Schema.Null, { exact: true }),
}).annotations({
    identifier: `${exports.NAMESPACE}.State`,
});
exports.Catalogue = (0, _util_1.makeCatalogue)(slots).annotations({
    identifier: `${exports.NAMESPACE}.Catalogue`,
});
const identifier = `${exports.NAMESPACE}.TanklessRo`;
class TanklessRo extends effect_1.Schema.Class(identifier)({
    model: effect_1.Schema.tag('tlro'),
    alarms: (0, _util_1.makeActiveAlarms)(alarms),
    consumables: (0, _util_1.makeSlottedConsumables)(slots),
    state: exports.State,
    latestTelemetry: effect_1.Schema.partialWith(exports.Telemetry, { exact: true }),
    latestTelemetryUpdate: effect_1.Schema.optionalWith(exports.LatestTelemetryUpdate, {
        exact: true,
        default: () => ({}),
    }),
    prefs: effect_1.Schema.optionalWith(Prefs.Prefs, { exact: true, default: () => Prefs.DEFAULT_PREFS }),
    vendor: vendor_1.Culligan.DeviceInfo,
    ...Base.CommonProps.fields,
}, { identifier }) {
    static code = 'tlro';
    static label = 'Global Tankless RO';
    static category = 'Reverse-Osmosis';
    static operatingModes = operatingModes;
    static powerProfiles = powerProfiles;
    static logLevels = logLevels;
    static alarms = alarms;
    static slots = slots;
    static sensors = sensors;
    static events = events;
    static commands = commands;
    static connectivity = connectivity;
    static connectionGateway = 'AzureIotHub';
    static image = null;
    static State = exports.State;
    static Prefs = Prefs.Prefs;
    static PrefsFromPartial = Prefs.PrefsFromPartial;
    static Telemetry = exports.Telemetry;
    static Catalogue = exports.Catalogue;
    static vendors = [vendor_1.Culligan.code];
    static init = (props, dates) => {
        return new this(Base.deviceInitProps({
            operatingMode: 'Startup',
            powerProfile: 'Standard',
            logLevel: 'Silent',
            connectivity: 'Wi-Fi',
        }, slots, null, props, dates));
    };
    get code() {
        return `${this.vendor.code}${this.model}`;
    }
    get consumableAlarms() {
        const filterAlarm = (0, _util_1.checkAlarmOnExpendableConsumable)(this.consumables[0], 0) ??
            (0, _util_1.checkAlarmOnExpirableConsumable)(this.consumables[0], 0);
        const membraneAlarm = (0, _util_1.checkAlarmOnExpendableConsumable)(this.consumables[1], 1);
        return [filterAlarm, membraneAlarm].filter(Predicate_1.isNotNull);
    }
    get telemetryAlarms() {
        return [];
    }
    // TODO(Q01): derive from the manufacturer serial number once its format is known
    get manufacturingInfo() {
        return effect_1.Option.none();
    }
    get failureModes() {
        return (0, failure_mode_1.getFailureModes)(this);
    }
}
exports.TanklessRo = TanklessRo;
//# sourceMappingURL=index.js.map